export const API_BASE_URL =
  import.meta.env.VITE_PUBLIC_APP_API_URL || 'https://api.dev.driver360.org'
